module.exports = __webpack_public_path__ + "img/carousel.9617f61f.png";